"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dependencyTypes = void 0;
/** Dependencies object attributes (type of dependency) */
exports.dependencyTypes = ['mapper', 'repository', 'useCase', 'controller', 'validator', 'decode', 'encode']; // decode and encode are deprecated but still used in the codebase. Remove them when possible
//# sourceMappingURL=types.js.map